module.exports = __webpack_public_path__ + "static/media/meloconton.ff4299fa.png";